/**
 * Small "Last used" badge, absolutely positioned at the right edge of an auth
 * button. Requires the parent button/container to be `relative`. Uses semantic
 * tokens so it adapts to dark mode; `pointer-events-none` keeps clicks on the
 * button underneath. See `src/lib/auth/last-method.ts`.
 *
 * `tone="onPrimary"` is for placement on a filled `bg-primary` button (the
 * magic-link submit), where the default primary-tinted pill would be too low
 * contrast; it flips to the primary-foreground palette instead.
 */
export function LastUsedPill({
	label,
	tone = "default",
}: {
	label: string;
	tone?: "default" | "onPrimary";
}) {
	const toneClasses =
		tone === "onPrimary"
			? "bg-primary-foreground/20 text-primary-foreground"
			: "bg-primary/10 text-primary";
	return (
		<span
			className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 rounded-full px-2 py-0.5 text-[11px] font-medium ${toneClasses}`}
		>
			{label}
		</span>
	);
}
